import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import MetaData from "../../components/layout/MetaData";
import PayPalButton from "../../components/PayPalButton";
import { useOrderDetailsQuery } from "../../redux/api/orderApi";
import BreadcrumbOrderDetails from "../../components/layout/Breadcrumb/breadcrumbOrderDetails";

const OrderDetails = () => {
  const { id: orderId } = useParams();
  const { data, isLoading, error, refetch } = useOrderDetailsQuery(orderId);
  const order = data?.order || {};

  const {
    shippingInfo,
    orderItems,
    paymentInfo,
    user,
    paidAt,
    totalAmount,
    orderStatus,
  } = order;

  const isPaid = paymentInfo?.status === "Paid" ? true : false;

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message);
    }
  }, [error]);

  if (isLoading) return <Loader />;

  return (
    <>
      <MetaData title={"Order Details"} />
      <BreadcrumbOrderDetails />
      <div className="flex justify-center">
        <div className="max-w-4xl w-full space-y-5 mt-5">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-semibold">Your Order Details</h3>
            <Link
              to={`/invoice/order/${orderId}`}
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
            >
              <i className="fa fa-print"></i> Invoice
            </Link>
          </div>
          <div className="bg-white shadow rounded-lg p-4">
            <table className="min-w-full">
              <tbody>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">Order ID:</th>
                  <td className="px-2 py-1">{order?._id}</td>
                </tr>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">Status:</th>
                  <td
                    className={
                      orderStatus?.includes("Delivered")
                        ? "text-green-500"
                        : "text-red-500"
                    }
                  >
                    <strong>{orderStatus}</strong>
                  </td>
                </tr>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">Date:</th>
                  <td className="px-2 py-1">
                    {new Date(order?.createdAt).toLocaleString("en-US")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="bg-white shadow rounded-lg p-4">
            <h3 className="text-lg font-semibold mb-3">Shipping Info:</h3>
            <table className="min-w-full">
              <tbody>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">Name:</th>
                  <td className="px-2 py-1">{user?.name}</td>
                </tr>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">Phone No:</th>
                  <td className="px-2 py-1">{shippingInfo?.phoneNo}</td>
                </tr>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">Address</th>
                  <td className="px-2 py-1">{`${shippingInfo?.address}, ${shippingInfo?.city}, ${shippingInfo?.zipCode}, ${shippingInfo?.country}`}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="bg-white shadow rounded-lg p-4">
            <h3 className="text-lg font-semibold mb-3">Payment Info:</h3>
            <table className="min-w-full">
              <tbody>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">Status:</th>
                  <td
                    className={`px-2 py-1 ${
                      isPaid ? "text-green-500" : "text-red-500"
                    }`}
                  >
                    {isPaid ? "Paid"  : "Not Paid"}  {paidAt && `at ${new Date(paidAt).toLocaleString("en-US")}`}
                  </td>
                </tr>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">Method:</th>
                  <td className="px-2 py-1">{order?.paymentMethod}</td>
                </tr>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">PayPal ID</th>
                  <td className="px-2 py-1">{paymentInfo?.id || "NA"}</td>
                </tr>
                <tr>
                  <th className="px-2 py-1 text-left font-medium">
                    Amount Paid
                  </th>
                  <td className="px-2 py-1">${totalAmount}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3 className="text-lg font-semibold my-4">Order Items:</h3>
          <div className="bg-white shadow rounded-lg p-4">
            {orderItems?.map((item, index) => (
              <div
                key={index}
                className="flex justify-between items-center my-3"
              >
                <img
                  src={item?.image}
                  alt={item?.name}
                  className="h-12 w-16 object-cover"
                />
                <Link
                  to={`/products/${item?.product?._id}`}
                  className="text-blue-600 hover:text-blue-800"
                >
                  {item?.name}
                </Link>
                <p className="text-gray-900">${item?.price}</p>
                <p className="text-gray-900">{item?.quantity} Piece(s)</p>
              </div>
            ))}
          </div>
          {!isPaid && (
            <PayPalButton
              paymentInfo={paymentInfo}
              totalAmount={totalAmount}
              orderId={orderId}
              order={order}
              refetch={refetch}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default OrderDetails;
